'use client'

import type { MediaBlockFieldsFragment } from '@/graphql/types'
import { useContentfulEntryLivePreview } from '@/components/providers/useContentfulEntryLivePreview'
import { richTextRendererDlp } from '../rich-text'
import { DynamicMediaBlock } from '@ccpgames/eve-web-core'
import { NextImageWrapper } from '@/components/shared/NextImageWrapper'

interface MediaBlockProps {
  entry: MediaBlockFieldsFragment
  flipped?: boolean
}

export function MediaBlock({ entry, flipped = false }: MediaBlockProps) {
  const { updatedEntry, inspectorProps } = useContentfulEntryLivePreview(entry)
  const title = updatedEntry.title ?? ''
  const text = updatedEntry.text
  const media = updatedEntry.media
  const imageUrl = media?.url ?? undefined

  // Don't render if there's no content to display
  if (!title && !text && !imageUrl) {
    return null
  }

  return (
    <div {...inspectorProps('text')}>
      <DynamicMediaBlock
        title={title}
        content={richTextRendererDlp(text)}
        image={
          imageUrl ? (
            <NextImageWrapper
              width={media?.width ?? undefined}
              height={media?.height ?? undefined}
              sizes="(min-width: 768px) 40vw, 100vw"
              src={imageUrl}
              quality={85}
              alt={media?.description ?? media?.title ?? ''}
            />
          ) : undefined
        }
        flipped={flipped}
      />
    </div>
  )
}
